module.exports = {
      id: "black-fb-usage",
      viewBox: "0 0 10 17",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#black-fb",
      toString: function () {
        return this.url;
      }
    }